import { C as CosmosButton$1, d as defineCustomElement$1 } from './p-B77_NHv6.js';

const CosmosButton = CosmosButton$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosButton, defineCustomElement };
